export default __webpack_public_path__ + "static/media/message-notification.afa9ae4e.wav";